<template>
  <div>
    <v-toolbar flat>
      <v-col cols="3">
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          clearable
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="2">
        <v-autocomplete
          v-model="disciplineFilter"
          :items="disciplines"
          :item-text="(item) => `${item.code} - ${item.name}`"
          item-value="disciplineId"
          label="Discipline"
          dense
          hide-details
          clearable
        ></v-autocomplete>
      </v-col>
      <v-col cols="2">
        <v-autocomplete
          v-model="languageFilter"
          :items="languages"
          item-text="name"
          item-value="languageId"
          label="Language"
          dense
          hide-details
          clearable
        ></v-autocomplete>
      </v-col>
      <v-col cols="2">
        <v-autocomplete
          v-model="zipCodeFilter"
          :items="zipCodes"
          item-text="text"
          item-value="id"
          label="Zip Code"
          dense
          hide-details
          clearable
        ></v-autocomplete>
      </v-col>
      <v-col sm="1">
        <v-switch
          label="Active"
          v-model="activeFilter"
          hide-details
          dense
        ></v-switch>
      </v-col>
      <v-spacer></v-spacer>
      <v-btn
        v-if="isAdmin"
        color="primary"
        small
        tile
        outlined
        depressed
        @click="goToNewProvider"
        ><v-icon small>mdi-plus</v-icon> New Provider</v-btn
      ><import-provider-modal v-if="isSEITAdmin"></import-provider-modal>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="filteredProviders"
      :search="search"
      @click:row="(item) => goToProvider(item)"
      :loading="providers.length == 0"
      loading-text="Loading..."
      :items-per-page="15"
      style="cursor: pointer"
      class="alt-shading"
    >
      <template v-slot:no-results
        ><v-card
          v-if="isAdmin"
          flat
          dense
          @click="goToNewProvider"
          class="text-center text-decoration-underline"
          ><v-card-text><v-btn small>New Provider</v-btn></v-card-text></v-card
        >
      </template></v-data-table
    >
  </div>
</template>

<script>
import ProviderForm from "./provider-form";
import ImportProviderModal from "./import-provider-modal";

export default {
  components: {
    ProviderForm,
    ImportProviderModal,
  },
  data() {
    return {
      headers: [
        {
          text: "Provider Id",
          value: "providerId",
        },
        {
          text: "Legacy Provider Id",
          value: "legacyProviderId",
          align: "left",
        },
        { text: "First Name", value: "firstName" },
        { text: "Last Name", value: "lastName" },
        { text: "Email Address", value: "emailAddress" },
      ],
      search: "",
      disciplineFilter: null,
      languageFilter: null,
      zipCodeFilter: null,
      activeFilter: true,
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters["securityModule/isAdmin"];
    },
    isSEITAdmin() {
      return this.$store.getters["securityModule/isSEITAdmin"];
    },
    providers() {
      return this.$store.state.optionsModule.providers || [];
    },
    filteredProviders() {
      return this.providers.filter(
        (x) =>
          (this.disciplineFilter == null ||
            x.disciplines.some(
              (item) => item.disciplineId == this.disciplineFilter
            )) &&
            (this.languageFilter == null || x.languages.some((item) => item.languageId == this.languageFilter)) && 
          (this.zipCodeFilter == null || x.zipCode == this.zipCodeFilter) &&
          (this.activeFilter == false || x.isActive == true)
      );
    },
    disciplines() {
      return this.$store.state.optionsModule.disciplines || [];
    },
    languages() {
      return this.$store.state.optionsModule.languages || [];
    },
    zipCodes() {
      return this.providers
        .filter((item) => Boolean(item.zipCode))
        .map((item) => {
          return {
            text: item.zipCode,
            id: item.zipCode,
          };
        })
        .sort((a, b) => a.text.localeCompare(b.text));
    },
  },
  methods: {
    goToProvider(item) {
      this.$router.push({
        name: "ProviderForm",
        params: { providerId: item.providerId },
      });
    },
    goToNewProvider() {
      this.$router.push({
        name: "NewProvider",
      });
    },
  },
};
</script>

<style lang="css" scoped>
.alt-shading >>> tr:nth-child(even) {
  background: #ccc;
}
</style>
